'use client';

import React from 'react';
import { NavbarContent, NavbarItem } from '@heroui/navbar';
import { Link } from '@heroui/link';
import { User } from '@/types/models/user';
import { useTranslations } from 'next-intl';
import {
  logHubxEvent,
  APP_EVENTS,
} from '@/lib/analytics/services/log-hubx-event';

const NavbarLinks = ({ isAuthenticated }: { isAuthenticated: boolean }) => {
  const translate = useTranslations();
  return (
    <NavbarContent className="!flex-initial [&_a]:navbar-link gap-8">
      {/* {!isAuthenticated && (
        <NavbarItem>
          <Link
            href="/pricing"
            className="hover:!text-primary-dark-blue !font-normal"
            onClick={() =>
              logHubxEvent({ eventName: APP_EVENTS.BTN_HEADER_PRICING })
            }
          >
            {translate('navbar.pricing')}
          </Link>
        </NavbarItem>
      )} */}
      <NavbarItem>
        <Link
          href="/blog"
          className="hover:!text-primary-dark-blue !font-normal"
        >
          {translate('navbar.blog')}
        </Link>
      </NavbarItem>
      <NavbarItem>
        <Link
          href="/faq"
          className="hover:!text-primary-dark-blue !font-normal"
        >
          {translate('navbar.faq')}
        </Link>
      </NavbarItem>
    </NavbarContent>
  );
};

export default NavbarLinks;
